$(document).on("click",".zoom-btn",function() {
  const productZoomSlider = new Swiper('.product__zoom-slider', {
    loop: true,
    pagination: {
      el: '.product__zoom-pagination',
    },
    navigation: {
      nextEl: '.product__zoom-button.swiper-button-next',
      prevEl: '.product__zoom-button.swiper-button-prev',
    }
  });
  
   var zoom_alt = $(this).parent('.product__media').find('img').attr('alt');
   const zoomContainer = $('.product__zoom');
   var index =   $('.product__zoom-item[data-alt="'+ zoom_alt +'"]').data('swiper-slide-index');
    productZoomSlider.slideToLoop(index);
    setTimeout(() => {
      zoomContainer.addClass('open');
  }, 150);
});

/* DISABLE RIGHT CIICK FUNTION */

// document.addEventListener('contextmenu', event => event.preventDefault());

document.onkeydown = function (e) {

  // disable F12 key
  if(e.keyCode == 123) {
      return false;
  }
  
}

document.addEventListener("DOMContentLoaded", (event) => {
  window.extractFloatNumber = function(inputString) {
    const regex = /[\d,]+\.\d{2}/;
    const match = inputString.match(regex);
    if (match) {
      const floatNumber = match[0].replace(/,/g, '');
      return parseFloat(floatNumber);
    } else {
      return null;
    }
  }

  window.updateSubtotalPrice = function(){
    let subtotalPrice = 0;
    document.querySelectorAll(".updated--price").forEach(el => {
      let quantity = el.closest(".cart-item__content").querySelector(".quantity__input").value;
      if(el.querySelectorAll("span").length == 0){
        subtotalPrice = subtotalPrice + (window.extractFloatNumber(el.innerText) * quantity);
      }
      else if(el.querySelectorAll("span").length > 0){
        subtotalPrice = subtotalPrice + (window.extractFloatNumber(el.querySelector("span").innerText) * quantity);
      }
    })
    
    let updatedFormattedMoney = subtotalPrice.toLocaleString(`${Shopify.locale}-${Shopify.country}`, { style: 'currency', currency: Shopify.currency.active });
    const updatedSubtotalElement = document.querySelector(".updated--subtotal");
    if(updatedSubtotalElement){
      updatedSubtotalElement.innerText = updatedFormattedMoney;
      updatedSubtotalElement.classList.remove("hidden");
    }
  }

  if(window.location.href.includes("/cart")){
    window.updateSubtotalPrice();
  }
  
});

class UpsellOptions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('click', (e) => {
      if (e.target.closest('.cart-upsell-dropdown__trigger')) {
    e.preventDefault();
    
    const trigger = e.target.closest('.cart-upsell-dropdown__trigger');
    const dropdown = trigger.closest('.cart-upsell-custom-dropdown');
    const list = dropdown.querySelector('.cart-upsell-dropdown__list');
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    
    document.querySelectorAll('.cart-upsell-dropdown__trigger').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.cart-upsell-dropdown__list').forEach(l => {
      l.classList.remove('open');
    });
    
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          list.classList.add('open');
        }
      }
      
      else if (e.target.closest('.cart-upsell-dropdown__option')) {
        e.preventDefault();
        const option = e.target.closest('.cart-upsell-dropdown__option');
        if (option.dataset.available === 'false') {
          return;
        }
        
        const dropdown = option.closest('.cart-upsell-custom-dropdown');
        const trigger = dropdown.querySelector('.cart-upsell-dropdown__trigger');
        const currentSpan = trigger.querySelector('.cart-upsell-dropdown__current');
        const list = dropdown.querySelector('.cart-upsell-dropdown__list');
        const container = this.closest('.upsell_product-container');
        
        dropdown.querySelectorAll('.cart-upsell-dropdown__option--selected').forEach(opt => {
          opt.classList.remove('cart-upsell-dropdown__option--selected');
        });
        option.classList.add('cart-upsell-dropdown__option--selected');
        
        currentSpan.textContent = option.dataset.title;        
        trigger.setAttribute('aria-expanded', 'false');
        list.classList.remove('open');
        
        const variantId = option.dataset.variantId;
        const price = option.dataset.price;
        const availability = option.dataset.availability;
        
        const addToCartBtn = container.querySelector('.js-add-to-cart');
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-id', variantId);

          const labelEl = addToCartBtn.querySelector('.cart-drawer__upsell-atcs-icon');
          const iconEl = addToCartBtn.querySelector('svg, .icon-plus');

          if (availability === 'soldout') {
            addToCartBtn.classList.add('soldout');
            addToCartBtn.setAttribute('disabled', 'disabled');
            addToCartBtn.setAttribute('aria-disabled', 'true');
            if (labelEl) labelEl.textContent = 'Sold Out';
            if (iconEl) iconEl.style.display = 'none';
          } else {
            addToCartBtn.classList.remove('soldout');
            addToCartBtn.removeAttribute('disabled');
            addToCartBtn.removeAttribute('aria-disabled');
            if (labelEl) labelEl.textContent = 'Add';
            if (iconEl) iconEl.style.display = '';
          }
        }
        
        const priceElement = container.querySelector('.upsell_price');
        if (priceElement) {
          priceElement.textContent = price;
        }
        
        const imageUrl = option.dataset.imageUrl;
        const imageAlt = option.dataset.imageAlt;
        const imageContainer = container.querySelector('.cart-drawer__upsell-image');
        
        if (imageUrl && imageContainer) {
          const img = imageContainer.querySelector('img');
          if (img) {
            img.src = imageUrl;
            img.alt = imageAlt || '';
            
            img.setAttribute('srcset', imageUrl);
          }
        }
      }
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('upsell-options')) {
        document.querySelectorAll('.cart-upsell-dropdown__trigger').forEach(trigger => {
          trigger.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.cart-upsell-dropdown__list').forEach(list => {
          list.classList.remove('open');
        });
      }
    });
  }
}

customElements.define('upsell-options', UpsellOptions);

class ProPackageUpgrade extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.init();
  }

  init(){
    this.checkbox = this.querySelector('.cart-item__pro-package-checkbox');
    this.proVariant = this.querySelector('.cart-item__pro-package-checkbox').dataset.proVariant;
    this.currentVariant = this.querySelector('.cart-item__pro-package-checkbox').dataset.currentVariant;
    this.freeGift = this.querySelector('.cart-item__pro-package-checkbox').dataset.freeGift;
    this.proProductHandle = this.querySelector('.cart-item__pro-package-checkbox').dataset.proProductHandle;
    this.proPackageCheckbox = this.querySelector('.pro-package-checkbox');
    this.proPackageVariants = null;

    // Skip binding interaction when the upgrade product is sold out
    if (this.querySelector('.cart-item__pro-package--sold-out')) {
      return;
    }

    this.checkbox.addEventListener('click', () => {
      this.proPackageCheckbox.classList.toggle('checked');
      this.upgradeProPackage();
    });
    
    if (this.proProductHandle) {
      this.fetchProPackageVariants();
    }
  }
  
  async fetchProPackageVariants() {
    try {
      const response = await fetch(`/products/${this.proProductHandle}.js`);
      const productData = await response.json();
      this.proPackageVariants = productData.variants;
    } catch (error) {
      console.error('Failed to fetch pro package variants:', error);
    }
  }
  
  findMatchingProPackageVariant(currentVariantTitle) {
    if (!this.proPackageVariants || this.proPackageVariants.length === 0 || !currentVariantTitle) {
      return null;
    }

    // Look for a variant that matches the current color
    return this.proPackageVariants.find(variant => {
      // Check if any of the variant's option values match the current variant's options
      return variant.option1 === currentVariantTitle || 
             variant.option2 === currentVariantTitle || 
             variant.option3 === currentVariantTitle ||
             variant.title === currentVariantTitle;
    });
  }

  async upgradeProPackage() {
    const cartItem = this.closest('.cart-item');
    if (cartItem) {
      cartItem.classList.add('cart-item--updating');
    }

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const currentVariantItem = cart.items.find(item =>
        String(item.variant_id) === String(this.currentVariant)
      );
      const currentQuantity = currentVariantItem ? currentVariantItem.quantity : 1;

      const oldFreeGiftLines = [];
      cart.items.forEach((item, index) => {
        if (item.properties && 
            item.properties._free_gift === 'true' && 
            String(item.properties._parent_variant_id) === String(this.currentVariant)) {
          oldFreeGiftLines.push(index + 1);
        }
      });
      
      for (const line of oldFreeGiftLines) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            line: line,
            quantity: 0
          })
        });
      }

      const addProResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: this.proVariant,
          quantity: currentQuantity
        })
      });
      const addedItem = await addProResponse.json();

      // Remove the old variant via update.js. change.js (by bare variant id or by
      // line key) is mishandled by this store's cart transform - it either returns
      // 400 or also strips the freshly added pro variant - whereas update.js keyed
      // by variant id removes only the original line and keeps the pro upgrade.
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          updates: { [this.currentVariant]: 0 }
        })
      });

      if (this.freeGift && addedItem && addedItem.variant_id) {
        const updatedCartResponse = await fetch('/cart.js');
        const updatedCart = await updatedCartResponse.json();
        
        const proVariantItem = updatedCart.items.find(item => 
          String(item.variant_id) === String(addedItem.variant_id)
        );
        
        if (proVariantItem) {
          const targetQuantity = proVariantItem.quantity;
          
          const existingFreeGift = updatedCart.items.find(item =>
            item.properties &&
            item.properties._free_gift === 'true' &&
            String(item.properties._parent_variant_id) === String(addedItem.variant_id) &&
            String(item.variant_id) === String(this.freeGift)
          );
          
          if (existingFreeGift) {
            if (existingFreeGift.quantity !== targetQuantity) {
              const freeGiftLine = updatedCart.items.findIndex(item => 
                item.properties &&
                item.properties._free_gift === 'true' &&
                String(item.properties._parent_variant_id) === String(addedItem.variant_id) &&
                String(item.variant_id) === String(this.freeGift)
              ) + 1;
              
              if (freeGiftLine > 0) {
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    line: freeGiftLine,
                    quantity: targetQuantity
                  })
                });
              }
            }
          } else {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: this.freeGift,
                quantity: targetQuantity,
                properties: {
                  _free_gift: 'true',
                  _parent_variant_id: String(addedItem.variant_id)
                }
              })
            });
          }
        }
      }

      this.refreshCartComponents();
    } catch (error) {
      if (cartItem) {
        cartItem.classList.remove('cart-item--updating');
      }
    }
  }

  refreshCartComponents() {
    const isCartPage = window.location.pathname === '/cart' || window.location.pathname.includes('/cart');
    
    if (isCartPage) {
      this.refreshCartPage();
    } else {
      this.refreshCartDrawer();
    }
  }

  refreshCartDrawer() {
    const sectionsToRender = [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content')?.dataset.id,
        selector: '.cart-drawer__content',
      }
    ];

    this.fetchAndUpdateSections(sectionsToRender);
  }

  refreshCartPage() {
    const sectionsToRender = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-total-summary',
        section: document.getElementById('main-cart-total-summary')?.dataset.id,
        selector: '.cart__blocks',
      }
    ];

    this.fetchAndUpdateSections(sectionsToRender);
  }

  fetchAndUpdateSections(sectionsToRender) {
    const body = JSON.stringify({
      updates: {},
      sections: sectionsToRender.map((section) => section.section).filter(Boolean),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(response => response.text())
    .then(state => {
      const parsedState = JSON.parse(state);
      
      sectionsToRender.forEach(section => {
        if (section.section && parsedState.sections && parsedState.sections[section.section]) {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }
      });
      const cartItem = this.closest('.cart-item');
      if (cartItem) {
        cartItem.classList.remove('cart-item--updating');
      }
    })
    .catch(() => {
      window.location.reload();
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('pro-package-upgrade', ProPackageUpgrade);

var swiper = new Swiper(".landing__collections--row", {
  slidesPerView: 2,
  spaceBetween: 30,
  centeredSlides: true,
  loop: true,
  allowTouchMove: true,
  pagination: {
    el: ".landing__collections--pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
      loop: false,
      centeredSlides: false,
      allowTouchMove: false,
    },
  },
});

// Match height js
function matchHeight(className) {
    var elements = document.querySelectorAll('.' + className);
    var rows = [];
    var currentRowTop = null;
    var currentRow = [];
    // Reset heights
    elements.forEach(function(element) {
        element.style.height = 'auto';
    });
    // Group elements by rows
    elements.forEach(function(element) {
        var rect = element.getBoundingClientRect();
        var top = rect.top;
        if (currentRowTop === null || top === currentRowTop) {
            currentRow.push(element);
            currentRowTop = top;
        } else {
            rows.push(currentRow);
            currentRow = [element];
            currentRowTop = top;
        }
    });
    rows.push(currentRow); // Push the last row
    // Apply max height to each row
    rows.forEach(function(row) {
        var maxHeight = 0;
        row.forEach(function(element) {
            var height = element.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        row.forEach(function(element) {
            element.style.height = maxHeight + 'px';
        });
    });
}
// Apply matchHeight on load, resize, and scroll
// window.addEventListener('load', function() {
//     matchHeight('product-card__title-container');
// });
// window.addEventListener('resize', function() {
//     matchHeight('product-card__title-container');
// });
// window.addEventListener('scroll', function() {
//     matchHeight('product-card__title-container');
// });




/* PDP L series JS start */

var swiperGallerySlider = new Swiper(".l__series--gallery-slider .swiper__gallery--slider", {
  slidesPerView: 1.3,
  centeredSlides: true,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".gallery-swiper-button-next",
    prevEl: ".gallery-swiper-button-prev",
  },
  pagination: {
    el: ".gallery-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
  }
});

// ----

// Function to update content__gallery--slider width
function updateContentGallerySliderWidth() {
    const activeSlide = document.querySelector(".swiper__gallery--slider .swiper-slide-active");
    const contentGallerySlider = document.querySelector(".content__gallery--slider");

    if (activeSlide && contentGallerySlider) {
        const activeSlideWidth = activeSlide.offsetWidth;
        contentGallerySlider.style.width = `${activeSlideWidth}px`;
    }
}

// Initialize Swiper instances
let isSyncing = false; // Prevents infinite loop

var swiperGalleryContentSliderPage = new Swiper(".swiper__content--slider", {
    loop: true,
    allowTouchMove: false,
    slidesPerView: 1,
    effect: "fade", // Smooth fade transition
    fadeEffect: { crossFade: true },
    pagination: {
        el: ".gallery-pagination",
        clickable: true,
    },
});

var swiperGallerySliderPage = new Swiper(".l__series--page-gallery-slider .swiper__gallery--slider", {
    slidesPerView: 1.3,
    centeredSlides: true, // Keeps the active slide centered
    spaceBetween: 10,
    loop: true,
    loopedSlides: 3, // Ensures smooth looping
    allowTouchMove: true,
    navigation: {
        nextEl: ".gallery-swiper-button-next",
        prevEl: ".gallery-swiper-button-prev",
    },
    pagination: {
        el: ".gallery-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
    },
    on: {
        init: updateContentGallerySliderWidth, // Update on init
        slideChangeTransitionEnd: updateContentGallerySliderWidth, // Update on slide change
    },
});

// Synchronize slides without infinite looping
swiperGallerySliderPage.on("slideChange", function () {
    if (!isSyncing) {
        isSyncing = true;
        swiperGalleryContentSliderPage.slideToLoop(swiperGallerySliderPage.realIndex);
        updateContentGallerySliderWidth(); // Update width after slide change
        setTimeout(() => (isSyncing = false), 10); // Delay to prevent recursion
    }
});

swiperGalleryContentSliderPage.on("slideChange", function () {
    if (!isSyncing) {
        isSyncing = true;
        swiperGallerySliderPage.slideToLoop(swiperGalleryContentSliderPage.realIndex);
        updateContentGallerySliderWidth(); // Update width after slide change
        setTimeout(() => (isSyncing = false), 10);
    }
});

// Listen for window resize and update width dynamically
window.addEventListener("resize", updateContentGallerySliderWidth);

// ----

if(window.innerWidth < 769){
  var swiperProductVariant = new Swiper('.swiper__product--variants', {
    slidesPerView: 2,
    spaceBetween: 30,
    centeredSlides: true,
    pagination: {
        el: '.product__variants--pagination',
        clickable: true,
    }
  });
}

/* PDP L series JS end */

// Header Height
document.addEventListener('DOMContentLoaded', function() {
  function updateHeaderHeight() {
    const announcementBar = document.querySelector('.announcement-bar');
    const header = document.querySelector('header');

    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;

    const totalHeight = announcementBarHeight + headerHeight;
    document.documentElement.style.setProperty('--top-header', `${totalHeight}px`);
  }

  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
});

function backButtonHandle() {
  const drawerBackLinks = Array.from(document.querySelectorAll('.menu-drawer__back'))
  drawerBackLinks.forEach(bl => {
    bl.addEventListener('click', () => {
      bl.closest('.menu-drawer__inner')?.querySelector('.menu-drawer__menu-level.active .menu-drawer__menu-header')?.click()
      document.querySelectorAll("drawer-accordion[open]").forEach(el => el.removeAttribute('open'));
    })
  })
}

backButtonHandle()
document.addEventListener('shopify:section:load', () => {
  backButtonHandle()
})
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations, obs) => {
    const freeGiftBox = document.querySelector(".qbk-promote-free-gift__content");
    const target = document.querySelector(".qbk-promote-ee");

    if (freeGiftBox && target) {
      target.appendChild(freeGiftBox);
      obs.disconnect();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

if(typeof DrawerAccordion !== "function") {
  class DrawerAccordion extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button')
      this.drawerList = this.querySelector('.menu-drawer__menu-list')
      this.drawerListInner = this.querySelector('.menu-drawer__menu-list_inner')
      this.handleClick = this.handleClick.bind(this);
      this.handleHeight = this.handleHeight.bind(this);
      this.menuLevelObserver = null;
    }

    static get observedAttributes() {
      return ['open'];
    }

    // Accessibility: expose the open state on the toggle and keep links inside a
    // collapsed list out of the tab order (it is only max-height: 0, not hidden)
    attributeChangedCallback() {
      this.syncA11yState();
    }

    syncA11yState() {
      const isOpen = this.hasAttribute('open');
      this.button?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (this.drawerList) this.drawerList.inert = !isOpen;
    }

    connectedCallback() {
      if (!this.button) return;

      this.syncA11yState();
      this.button.addEventListener("click", this.handleClick);
      this.handleHeight();
      window.addEventListener('resize', this.handleHeight);

      const menuLevel = this.closest('.menu-drawer__menu-level');
      if (menuLevel) {
        this.menuLevelObserver = new MutationObserver(() => {
          if (menuLevel.classList.contains('active')) {
            this.scheduleHeightUpdate();
          }
        });
        this.menuLevelObserver.observe(menuLevel, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }

      const menuDrawer = document.getElementById('menu-drawer');
      if (menuDrawer) {
        this.drawerObserver = new MutationObserver(() => {
          if (menuDrawer.getAttribute('aria-hidden') === 'false') {
            this.scheduleHeightUpdate();
          }
        });
        this.drawerObserver.observe(menuDrawer, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
        });
      }

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => this.handleHeight());
      }
    }
    
    disconnectedCallback() {
      this.button?.removeEventListener("click", this.handleClick);
      window.removeEventListener('resize', this.handleHeight);
      this.menuLevelObserver?.disconnect();
      this.drawerObserver?.disconnect();
    }

    handleClick() {
      const isOpening = !this.hasAttribute('open');

      document.querySelectorAll("drawer-accordion[open]").forEach(el => {
        if (el !== this) el.removeAttribute('open');
      });

      if (isOpening) {
        this.setAttribute('open', true);
        this.scheduleHeightUpdate();
      } else {
        this.removeAttribute('open');
      }
    }

    scheduleHeightUpdate() {
      requestAnimationFrame(() => {
        this.handleHeight();
        requestAnimationFrame(() => this.handleHeight());
      });
    }

    handleHeight() {
      if (!this.drawerList || !this.drawerListInner) return;

      const list = this.drawerList;
      const inner = this.drawerListInner;
      const previousMaxHeight = list.style.maxHeight;

      // Measure unclamped — iOS under-reports scrollHeight inside transformed/off-screen parents
      list.style.maxHeight = 'none';
      const measuredHeight = Math.max(
        inner.scrollHeight,
        inner.offsetHeight,
        Math.ceil(inner.getBoundingClientRect().height)
      );
      list.style.maxHeight = previousMaxHeight;

      list.style.setProperty('--menu-list-height', `${measuredHeight + 8}px`);
    }
  }

  customElements.define('drawer-accordion', DrawerAccordion);
}